import React, { useEffect, useState } from "react";
import Button from "sushiweb/Button";
import * as UserActions from "../../store/actions/User";
import * as RestrictedPayoutDriversActions from "../../store/actions/RestrictedPayoutDrivers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RestrictedPayoutDriverList from "../../components/RestrictedPayoutDrivers/index";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import { isValNull } from "../../utils/index";

const RestrictedPayoutDrivers = (props) => {
  const { setStatus, getRestrictedPayoutDrivers, restrictedPayoutDrivers } =
    props;
  const [driverId, setDriverId] = useState("");

  const handleChange = (val) => {
    setDriverId(val);
  };

  const handleClick = () => {
    if (isValNull(driverId)) {
      setStatus({ type: "error", message: "Please Enter Driver Id" });
      return;
    }

    getRestrictedPayoutDrivers(driverId);
  };

  return (
    <div className="Driver-Tags-View container">
      <FlexContainer align="flex-start">
        <Heading>Restricted Payout Drivers</Heading>
        <div className="mb-20 flex items-center justify-end">
          <Input
            value={driverId}
            data-testid="driverId"
            id="sushi-input"
            onChange={(e) => handleChange(e)}
            label="Driver ID or FE ID"
          />
          <div className={"mb-20"}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn mb-10"
              data-testid="restrictedPayoutDriverSubmitBtn"
            >
              Submit
            </Button>
          </div>
        </div>
      </FlexContainer>
      <RestrictedPayoutDriverList list={restrictedPayoutDrivers} />
    </div>
  );
};

function mapStateToProps(state) {
  const { RestrictedPayoutDrivers } = state;
  return {
    restrictedPayoutDrivers: RestrictedPayoutDrivers.restrictedPayoutDrivers,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getRestrictedPayoutDrivers: bindActionCreators(
      RestrictedPayoutDriversActions.getRestrictedPayoutDrivers,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestrictedPayoutDrivers);
